<div [ngClass]="{'left-aligned': !!leftAlight}">
  <h1 *ngIf="header" [innerHTML]="header"></h1>
  <p *ngIf="message" [innerHTML]="message"></p>
  <div class="ds-button-wrap">
    <button *ngIf="discardButtonTxt" class="{{discardButtonClass}}" [ngClass]="{'ds-btn-disabled': loading}" (click)="closeDialog(false)">
      <span [innerHTML]="discardButtonTxt | lowerCaseSpecificWords"></span>
    </button>
    <button *ngIf="secondaryBtnText" class="ds-btn-outline-gray {{discardButtonClass}}" [ngClass]="{'ds-btn-disabled': loadingSecondary || loading}" (click)="secondaryButtonAction('secondary')">
      <span *ngIf="!loadingSecondary" [innerHTML]="secondaryBtnText | lowerCaseSpecificWords"></span>
      <db-loading-circular-spinner *ngIf="loadingSecondary"></db-loading-circular-spinner>
    </button>
    <button *ngIf="buttonTxt" class="ds-btn-blue {{buttonAdditionalClass}}" [ngClass]="{'ds-btn-disabled': loadingSecondary || loading}" (click)="closeDialog('primary')">
      <span *ngIf="!loading && !!uppercaseWords" [innerHTML]="buttonTxt | lowerCaseSpecificWords"></span>
      <span *ngIf="!loading && !uppercaseWords" [innerHTML]="buttonTxt"></span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </button>
  </div>
</div>

